import { Stack } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DashboardComponents } from "@/features/dashboard/_components/dashboard";
import { CompanyForm } from "@/features/dashboard/empresas/_components/CompanyForm";

export const Route = createFileRoute("/_private/dashboard/_base/empresas/cadastrar/")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <Stack>
      <DashboardComponents.Title>Cadastrar Empresa</DashboardComponents.Title>

      <CompanyForm />
    </Stack>
  );
}
